const MetaNotFound = () => (
  <>
    <title>Side ikke fundet | Svanes Dyr</title>
    <meta name="robots" content="noindex, nofollow" />
    <meta name="description" content="Siden kunne ikke findes" />
  </>
);

export default MetaNotFound;
